<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div>
          <div class="title">APK 发布管理</div>
          <div class="muted">上传完整 APP 安装包，APP 检查更新时会在 WGT 热更新之后继续识别 APK 更新。</div>
        </div>
        <el-button icon="el-icon-refresh" @click="getList">刷新</el-button>
      </div>

      <el-form :model="form" label-width="110px" class="publish-form">
        <el-form-item label="上传 APK">
          <el-upload
            action="/api/admin/app/apk/upload"
            :headers="uploadHeaders"
            :show-file-list="false"
            accept=".apk"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload"
          >
            <el-button type="primary" icon="el-icon-upload">选择 .apk 文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="版本号">
          <el-input v-model="form.version" placeholder="例如 1.0.2"></el-input>
        </el-form-item>
        <el-form-item label="版本码">
          <el-input-number v-model="form.version_code" :min="1" style="width: 180px"></el-input-number>
          <span class="muted inline-tip">必须大于当前原生 APK versionCode 才会触发安装包更新</span>
        </el-form-item>
        <el-form-item label="APK 地址">
          <el-input v-model="form.apk_url" placeholder="上传后自动填入"></el-input>
        </el-form-item>
        <el-form-item label="文件信息">
          <div class="muted">文件：{{ form.file_name || "-" }}，大小：{{ form.file_size || 0 }} bytes，MD5：{{ form.md5 || "-" }}</div>
        </el-form-item>
        <el-form-item label="强制更新">
          <el-switch v-model="form.force_update" :active-value="1" :inactive-value="0" active-text="弹窗不可取消"></el-switch>
        </el-form-item>
        <el-form-item label="发布状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用为最新安装包"></el-switch>
        </el-form-item>
        <el-form-item label="更新说明">
          <el-input type="textarea" v-model="form.remark" :rows="3" placeholder="可填写安装包更新说明"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存发布</el-button>
          <el-button @click="resetForm">清空</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border height="46vh">
        <el-table-column label="版本" width="120">
          <template slot-scope="scope">{{ scope.row.version }}</template>
        </el-table-column>
        <el-table-column label="版本码" width="100" prop="version_code"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'info'">{{ Number(scope.row.status) === 1 ? "启用" : "停用" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="强制" width="90">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.force_update) === 1 ? 'danger' : 'info'">{{ Number(scope.row.force_update) === 1 ? "是" : "否" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="APK地址" min-width="260">
          <template slot-scope="scope">
            <el-link :href="scope.row.apk_url" target="_blank" type="primary">{{ scope.row.apk_url }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.updated_at || scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess } from "./appAdminUtils.js";

export default {
  name: "appApk",
  data() {
    return {
      list: [],
      form: this.emptyForm(),
    };
  },
  computed: {
    uploadHeaders() {
      return {
        Authorization: localStorage.getItem("token") || "",
      };
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    formatTime,
    emptyForm() {
      return {
        id: "",
        version: "",
        version_code: 1,
        apk_url: "",
        file_name: "",
        file_size: 0,
        md5: "",
        remark: "",
        force_update: 0,
        status: 1,
      };
    },
    getList() {
      post("/api/admin/app/apk/list", {}).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "APK 列表获取失败");
        }
      });
    },
    beforeUpload(file) {
      const ok = /\.apk$/i.test(file.name);
      if (!ok) {
        this.$message.error("只能上传 .apk 文件");
      }
      return ok;
    },
    uploadSuccess(res) {
      if (res.code !== 1001) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      const data = res.data || res;
      this.form.apk_url = data.apk_url || data.url;
      this.form.file_name = data.file_name;
      this.form.file_size = data.file_size;
      this.form.md5 = data.md5;
      this.$notify({ title: "上传成功", message: "APK 文件信息已填入", type: "success" });
    },
    save() {
      if (!this.form.version || !this.form.version_code || !this.form.apk_url) {
        this.$message.error("请填写版本号、版本码并上传 APK 文件");
        return;
      }
      post("/api/admin/app/apk/save", this.form).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.resetForm();
          this.getList();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    edit(row) {
      this.form = Object.assign(this.emptyForm(), row);
    },
    resetForm() {
      this.form = this.emptyForm();
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.title {
  color: #1f2d3d;
  font-size: 20px;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.inline-tip {
  margin-left: 12px;
}
.publish-form {
  max-width: 860px;
  margin-bottom: 20px;
}
</style>
